// extracted by mini-css-extract-plugin
export var productImage = "_q7-1";
export var viewLink = "_q7-2";
export var wishlistItem = "_q7-0";